import { BadgeCheck, BadgePercent, Ban, BarChart3, BookOpenCheck, Boxes, Briefcase, Building2, CalendarCheck, CalendarClock, CalendarClock as CalendarDays, CalendarRange, CalendarX2, ClipboardCheck, ClipboardList, Clock, Coins, DatabaseZap, DoorOpen, Factory, FileBarChart, FileText, Hash, History, KeyRound, Landmark, Layers, ListTree, Network, Package, PackageCheck, PackagePlus, PieChart, PiggyBank, Receipt, ReceiptText, Repeat, Ruler, Scale, ScrollText, Settings, Settings2, ShieldAlert, ShieldCheck, ShoppingBag, ShoppingCart, SlidersHorizontal, Tags, Truck, Undo2, UserCheck, UserRound, Users, Wallet, Warehouse, type LucideIcon } from 'lucide-react';

/** Sidebar / command-palette icon per screen. Unknown screens fall back by name, then to a document icon. */
const ICONS: Record<string, LucideIcon> = {
  purchase_bills: Receipt,
  purchase_returns: Repeat,
  stock_valuation: BarChart3,
  inventory_reports: FileBarChart,
  chart_of_accounts: ListTree,
  posting_accounts: Settings2,
  all_vouchers: Layers,
  voucher_manager: ClipboardCheck,
  pending_vouchers: ClipboardCheck,
  rectification_vouchers: Undo2,
  approved_vouchers: BadgeCheck,
  cancelled_vouchers: Ban,
  period_close: CalendarCheck,
  general_ledger: BookOpenCheck,
  accounting_settings: Settings2,
  inventory_settings: Settings2,
  journal_vouchers: ScrollText,
  receipts: ReceiptText,
  payments: Wallet,
  allocations: Network,
  cheques: BookOpenCheck,
  recovery_cases: ShieldAlert,
  purchase_vouchers: ShoppingBag,
  salary_vouchers: Wallet,
  bank_reconciliation: Landmark,
  financial_reports: FileBarChart,
  legacy_reconciliation: History,
  salespersons: UserCheck,
  products: Package,
  item_categories: Tags,
  uoms: Ruler,
  cost_centres: PieChart,
  tax_codes: BadgePercent,
  payment_terms: CalendarDays,
  bank_accounts: Landmark,
  cheque_books: BookOpenCheck,
  designations: Briefcase,
  customers: UserRound,
  quotations: FileText,
  sales_orders: ClipboardList,
  items: Boxes,
  suppliers: Building2,
  warehouses: Warehouse,
  purchasing_rules: ShieldCheck,
  purchasing_cutover: DatabaseZap,
  order_material: ListTree,
  approvals: ClipboardCheck,
  special_requests: FileText,
  out_gate_passes: Truck,
  shelves: Warehouse,
  planning_check: ShieldCheck,
  production_returns: Undo2,
  raw_materials: Boxes,
  finished_goods: Package,
  reorder: Repeat,
  held_stock: PackageCheck,
  purchase_requisitions: ClipboardCheck,
  purchase_orders: ShoppingCart,
  goods_receipts: PackagePlus,
  stock_issues: PackageCheck,
  stock_transfers: Repeat,
  stock_adjustments: SlidersHorizontal,
  boms: ListTree,
  production_plans: CalendarRange,
  material_requisitions: ClipboardCheck,
  work_orders: Factory,
  production_entries: Layers,
  fg_transfers: PackageCheck,
  delivery_notes: Truck,
  tax_invoices: ReceiptText,
  credit_notes: Receipt,
  employees: Users,
  attendance: Clock,
  leave_balances: Scale,
  allowances: Coins,
  gratuity: PiggyBank,
  final_settlements: DoorOpen,
  activity_log: History,
  payroll_runs: Wallet,
  users: Users,
  roles: ShieldCheck,
  audit_log: History,
  login_history: KeyRound,
  company: Settings2,
  branches: Building2,
  departments: Network,
  ui_kit: SlidersHorizontal,
  numbering: Hash,
  fiscal_periods: CalendarClock,
  backdating: CalendarX2,
  settings: Settings,
  migration: DatabaseZap,
};

export const screenIcon = (key: string): LucideIcon =>
  ICONS[key] ?? (key.endsWith('reports') ? FileBarChart : key.includes('report') ? BarChart3 : FileText);
